module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/1cover"
    }
  }, [_vm._v("The Bastard")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/6chap1#chap1"
    }
  }, [_vm._v("Book One Fortune’s Whirlwind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/7chap2#chap2"
    }
  }, [_vm._v("Chapter I - The Beating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/8chap3#chap3"
    }
  }, [_vm._v("Chapter II - Behind the Madonna")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/9chap4#chap4"
    }
  }, [_vm._v("Chapter III - Blood in the Snow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/10chap5#chap5"
    }
  }, [_vm._v("Chapter IV - Kentland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/11chap6#chap6"
    }
  }, [_vm._v("Chapter V - A Game of Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/12chap7#chap7"
    }
  }, [_vm._v("Chapter VI - “A Perfect Member of the Mob-ility”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/13chap8#chap8"
    }
  }, [_vm._v("Chapter VII - Brother Against Brother")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/14chap9#chap9"
    }
  }, [_vm._v("Chapter VIII - Trap")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/15chap10#chap10"
    }
  }, [_vm._v("Chapter IX - Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/16chap11#chap11"
    }
  }, [_vm._v("Book Two The House of Sholto and Sons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/17chap12#chap12"
    }
  }, [_vm._v("Chapter I - Swords at St Paul’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/18chap13#chap13"
    }
  }, [_vm._v("Chapter II - The Black Miracle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/19chap14#chap14"
    }
  }, [_vm._v("Chapter III - Mr. Burke and Dr. Franklin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/20chap15#chap15"
    }
  }, [_vm._v("Chapter IV - The Wizard of Craven Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/21chap16#chap16"
    }
  }, [_vm._v("Chapter V - The One-Eyed Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/22chap17#chap17"
    }
  }, [_vm._v("Chapter VI - The Bristol Coach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/23chap18#chap18"
    }
  }, [_vm._v("Chapter VII - To an Unknown Shore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/24chap19#chap19"
    }
  }, [_vm._v("Book Three Liberty Tree")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/25chap20#chap20"
    }
  }, [_vm._v("Chapter I - The Secret Room")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/26chap21#chap21"
    }
  }, [_vm._v("Chapter II - Mistress Anne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/27chap22#chap22"
    }
  }, [_vm._v("Chapter III - September Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/28chap23#chap23"
    }
  }, [_vm._v("Chapter IV - Night of the Axe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/29chap24#chap24"
    }
  }, [_vm._v("Chapter V - Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/30chap25#chap25"
    }
  }, [_vm._v("Chapter VI - The Sergeant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/31chap26#chap26"
    }
  }, [_vm._v("Chapter VII - Betrayal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/32chap27#chap27"
    }
  }, [_vm._v("Chapter VIII - Journey to Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/33chap28#chap28"
    }
  }, [_vm._v("Book Four The Road From Concord Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/34chap29#chap29"
    }
  }, [_vm._v("Chapter I - The Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/35chap30#chap30"
    }
  }, [_vm._v("Chapter II - A Death in Philadelphia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/36chap31#chap31"
    }
  }, [_vm._v("Chapter III - Alicia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/37chap32#chap32"
    }
  }, [_vm._v("Chapter IV - Too Much for the Whistle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/38chap33#chap33"
    }
  }, [_vm._v("Chapter V - Alarm at Midnight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/39chap34#chap34"
    }
  }, [_vm._v("Chapter VI - “God Damn It, They Are Firing Ball!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/40chap35#chap35"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/1cover"
    }
  }, [_vm._v("The Rebels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/6start#chap1"
    }
  }, [_vm._v("Book One "), _c('i', [_vm._v("Our Lives, Our Fortunes and Our Sacred Honor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/7chap2#chap2"
    }
  }, [_vm._v("Chapter I. A Taste of Steel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/8chap3#chap3"
    }
  }, [_vm._v("Chapter II. Sermon Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/9chap4#chap4"
    }
  }, [_vm._v("Chapter III. Birth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/10chap5#chap5"
    }
  }, [_vm._v("Chapter IV. The Uprising")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/11chap6#chap6"
    }
  }, [_vm._v("Chapter V. The Guns of Winter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/12chap7#chap7"
    }
  }, [_vm._v("Chapter VI “The Seedtime of Continental Union”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/13chap8#chap8"
    }
  }, [_vm._v("Chapter VII. The Thirteen Clocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/14chap9#chap9"
    }
  }, [_vm._v("Book Two "), _c('i', [_vm._v("The Times That Try Men’s Souls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/15chap10#chap10"
    }
  }, [_vm._v("Chapter I. The Privateers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/16chap11#chap11"
    }
  }, [_vm._v("Chapter II. Deed of Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/17chap12#chap12"
    }
  }, [_vm._v("Chapter III. Reunion in Pennsylvania")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/18chap13#chap13"
    }
  }, [_vm._v("Chapter IV. Retreat at Brandywine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/19chap14#chap14"
    }
  }, [_vm._v("Chapter V “I Mean to March to Hostile Ground”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/20chap15#chap15"
    }
  }, [_vm._v("Chapter VI. The Drillmaster")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/21chap16#chap16"
    }
  }, [_vm._v("Chapter VII. Rackham")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/22chap17#chap17"
    }
  }, [_vm._v("Book Three "), _c('i', [_vm._v("Death and Resurrection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/23chap18#chap18"
    }
  }, [_vm._v("Chapter I. The Wolves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/24chap19#chap19"
    }
  }, [_vm._v("Chapter II. The Guns of Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/25chap20#chap20"
    }
  }, [_vm._v("Chapter III. The Shawnee Spy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/26chap21#chap21"
    }
  }, [_vm._v("Chapter IV. The Price of Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/27chap22#chap22"
    }
  }, [_vm._v("Chapter V. The Woman From Virginia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/28chap23#chap23"
    }
  }, [_vm._v("Epilogue The World Turned Upside Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/29chap24#chap24"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text-A1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/1cover"
    }
  }, [_vm._v("The Seekers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/5start#chap1"
    }
  }, [_vm._v("Introduction:"), _c('br'), _vm._v("The Author as (Bad?) Actor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/7chap2#chap2"
    }
  }, [_vm._v("The Kent Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/8chap3#chap3"
    }
  }, [_vm._v("Book One: Kent and Son")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/9chap4#chap4"
    }
  }, [_vm._v("Chapter I Battle Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/10chap5#chap5"
    }
  }, [_vm._v("Chapter II The Charge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/11chap6#chap6"
    }
  }, [_vm._v("Chapter III Clouds at Homecoming")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/12chap7#chap7"
    }
  }, [_vm._v("Chapter IV The Storm Breaks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/13chap8#chap8"
    }
  }, [_vm._v("Chapter V “Scenes of Life Among the Mighty”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/14chap9#chap9"
    }
  }, [_vm._v("Chapter VI Wedding Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/15chap10#chap10"
    }
  }, [_vm._v("Chapter VII Wagon Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/16chap11#chap11"
    }
  }, [_vm._v("Chapter VIII Ark to the Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/17chap12#chap12"
    }
  }, [_vm._v("Book Two: The Enemy Land")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/18chap13#chap13"
    }
  }, [_vm._v("Chapter I The Cabin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/19chap14#chap14"
    }
  }, [_vm._v("Chapter II Old Ghosts and New Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/20chap15#chap15"
    }
  }, [_vm._v("Chapter III The Burning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/21chap16#chap16"
    }
  }, [_vm._v("Chapter IV Problems of a Modernist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/22chap17#chap17"
    }
  }, [_vm._v("Chapter V The Mark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/23chap18#chap18"
    }
  }, [_vm._v("Chapter VI Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/24chap19#chap19"
    }
  }, [_vm._v("Book Three: Voices of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/25chap20#chap20"
    }
  }, [_vm._v("Chapter I Jared")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/26chap21#chap21"
    }
  }, [_vm._v("Chapter II A Mackerel by Moonlight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/27chap22#chap22"
    }
  }, [_vm._v("Chapter III The Frigate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/28chap23#chap23"
    }
  }, [_vm._v("Chapter IV The Devil’s Companion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/29chap24#chap24"
    }
  }, [_vm._v("Chapter V “Her Sides Are Made of Iron!”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/30chap25#chap25"
    }
  }, [_vm._v("Chapter VI Heritage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/31chap26#chap26"
    }
  }, [_vm._v("Book Four: Cards of Fate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/32chap27#chap27"
    }
  }, [_vm._v("Chapter I Mr. Piggott")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/33chap28#chap28"
    }
  }, [_vm._v("Chapter II Act of Vengeance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/34chap29#chap29"
    }
  }, [_vm._v("Chapter III Act of Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/35chap30#chap30"
    }
  }, [_vm._v("Chapter IV Ordeal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/36chap31#chap31"
    }
  }, [_vm._v("Chapter V Reverend Blackthorn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/37chap32#chap32"
    }
  }, [_vm._v("Chapter VI Judge Jackson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/38chap33#chap33"
    }
  }, [_vm._v("Chapter VII Pursuit to St. Louis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/39chap34#chap34"
    }
  }, [_vm._v("Chapter VIII The Windigo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/40chap35#chap35"
    }
  }, [_vm._v("Chapter IX “I Will Seek That Which Was Lost”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/41chap36#chap36"
    }
  }, [_vm._v("Epilogue In the Tepee of the Dog Soldier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/teaser00",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("The Furies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/42abouttheauthor#biography"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77ad39dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 69
// module chunks = 0